/**
 * @(#)2019/6/17.
 * String，可以输入所有内容
 * @author 飞光
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */

import Basics from "./Basics";
import { isEqual, isString } from "lodash";
import { Select } from "antd";
import { isArray, isFunction } from "lodash";
import ReactDOM from "react-dom";
import { get, set, cloneDeep } from "../../utils";
import React, { Component } from "react";
import request from "../../utils/request";
import { YxComponent, Route, Connection } from "../YxComponent";
import { ISelectPropTypes } from "./IpropType/selectPropType";

/*
 * @param data {array} 用于循环显示下拉列表，必须包含value和label
 * @param data[x].value {string} 用于下拉框项的值
 * @param data[x].label {string} 用于下拉框项的显示内容
 * @param requestParam 用于请求
 * @param requestDefaultValue {boolean} 默认false
 * @param version 版本号不一致时重新请求
 * @param isSearchRefresh 是否在onSearch的时候重新请求数据，只有存在远程数据请求时才生效
 * */
//默认props
let defaul = () => {
  return {
    children: "", //子节点
    data: "", //用于循环显示下拉列表，必须包含key和label
    rules: {
      max: "",
    },
    inputParam: {},
    styleParam: {
      width: "sm", //宽度  xxs,xs,sm,md,lg,xl
      size: "default", //大小
      type: "default", //类型
    },
    isBool: "false", //开启默认在option加入true,false,默认defaultValue设置为true,  defaultValue> requestDefaultValue>isBool
    version: "", //版本号
    isSearchRefresh: false, //是否在onChange的时候重新请求数据，只有存在远程数据请求时才生效
  };
};
@Connection(defaul)
class YxSelect extends YxComponent {
  constructor(props, context) {
    super(props, context);
    let mode = get(this.props, "inputParam.mode", false);
    this.state = {
      data: [],
      defaultValue: mode === "multiple" ? [] : "",
    };
    this.version = null;
    this.isBoolArray = [
      { label: "是", value: true },
      { label: "否", value: false },
    ];
  }

  componentDidMount() {
    this.dataList(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.dataList(nextProps);
  }

  /**
   * 请求远程数据
   * searchValue 如果有搜索功能，将搜索的值设置为远程请求的参数
   */
  async dataList(props, searchValue = "") {
    const version = props.version;
    const requestParam = props.requestParam;
    searchValue && set(requestParam, `data.${props.id}`, searchValue);
    if (requestParam && !isEqual(this.version, version)) {
      this.version = version;
      let { data } = await request(requestParam);
      const data_ = get(data, "list", false) || data || [];
      this.setState({ data: data_, defaultValue: get(data_, "[0].value") });
    }
  }

  //处理搜索相关事宜
  search(tmpProps) {
    let onSearch = get(tmpProps, "inputParam.onSearch");
    //存在搜索更新功能，存在远程数据
    if (get(tmpProps, "isSearchRefresh") && get(tmpProps, "requestParam")) {
      set(tmpProps, "inputParam.onSearch", (data) => {
        isFunction(onSearch) && onSearch(data);
        this.version = Math.random();
        this.dataList(tmpProps, data);
      });
    }
    return tmpProps;
  }

  productionHtml() {
    let THIS = this;
    let { defaultValue } = this.state;
    let optionHtml = [];
    let tmpProps = { ...this.props };
    if (!tmpProps.defaultValue && tmpProps.requestDefaultValue)
      tmpProps.defaultValue = defaultValue;
    let propsData = get(tmpProps, "data", "");
    if (propsData && isArray(propsData)) {
      THIS.state.data = propsData;
    }

    //处理默认值
    let mode = get(this.props, "inputParam.mode", false);
    if (mode === "multiple" && !isArray(tmpProps.defaultValue)) {
      console.error("select [mode=multiple] 多选模式,默认值的数据类型为array");
      tmpProps.defaultValue = [];
    }

    let data = [];
    if (tmpProps.isBool == "true" || tmpProps.isBool === true) {
      if (!tmpProps.defaultValue && !tmpProps.requestDefaultValue)
        tmpProps.defaultValue = true;
      data = [...THIS.state.data, ...this.isBoolArray];
    } else {
      data = THIS.state.data instanceof Array && THIS.state.data;
    }
    data.map((item, index) => {
      optionHtml.push(
        <Select.Option key={index} {...item}>
          {item.label}
        </Select.Option>
      );
    });
    tmpProps.children = <Select>{optionHtml}</Select>;
    //配置样式
    let classParam = {
      yx_yxSelect_: "styleParam.type",
      yx_yxSelect_size_: "styleParam.size",
      yx_yxInput_width_: "styleParam.width",
    };
    tmpProps = this.search(tmpProps); //处理搜索相关
    tmpProps.inputParam.className = this.styleParamClassName(
      tmpProps,
      classParam
    );
    let html = Basics.html(tmpProps);
    return html;
  }
  render() {
    return <div className="yx_yxInput_yxSelect">{this.productionHtml()}</div>;
  }
}

YxSelect.propTypes = ISelectPropTypes;
YxSelect.defaultProps = defaul();

export default YxSelect;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/YxSelect.js